import {MatchMode} from '@wandb/weave/common/util/columnMatching';
import {Select} from '@wandb/weave/components/Form/Select';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React from 'react';

const SEARCH_OPTIONS: {label: string; value: MatchMode}[] = [
  {
    label: 'Fuzzy',
    value: 'fuzzy',
  },
  {
    label: 'Exact',
    value: 'exact',
  },
  {
    label: 'RegExp',
    value: 'regex',
  },
];

type TableEditorSearchProps = {
  matchMode: MatchMode;
  onSetMatchMode: (mode: MatchMode) => void;
  onSetSearch: (search: string) => void;
  search: string;
};

export function TableEditorSearch({
  matchMode,
  onSetMatchMode,
  onSetSearch,
  search,
}: TableEditorSearchProps) {
  const searchMode = SEARCH_OPTIONS.find(option => option.value === matchMode);

  return (
    <div className="flex items-center gap-8">
      <TextField
        icon="search"
        ariaLabel="Search columns"
        placeholder="Search columns"
        value={search}
        onChange={onSetSearch}
      />
      <Select
        options={SEARCH_OPTIONS}
        className="shrink-0"
        aria-label="Search mode"
        isSearchable={false}
        value={searchMode}
        onChange={option => {
          if (option) {
            onSetMatchMode(option.value);
          }
        }}
      />
    </div>
  );
}
